<template>
  <nav
    class="lg:hidden fixed bottom-0 inset-x-0 z-30 border-t border-primary-400 bg-primary-700/95 backdrop-blur"
    style="padding-bottom: env(safe-area-inset-bottom)"
    :aria-label="$t('nav.primary')"
  >
    <div class="flex items-stretch justify-around">
      <router-link
        v-for="tab in tabs"
        :key="tab.to"
        :to="tab.to"
        activeClass="text-highlight"
        class="flex-1 flex flex-col items-center gap-1 py-2.5 text-muted hover:text-highlight"
      >
        <span class="relative">
          <Font-awesome-icon :icon="['fas', tab.icon]" size="lg" />
          <span
            v-if="tab.count"
            class="absolute -top-2 -right-3 flex h-4 px-1 items-center justify-center rounded-full bg-highlight text-primary-700 text-[10px] font-semibold"
            aria-hidden="true"
          >
            {{ tab.count }}
          </span>
          <span v-if="tab.count" class="sr-only">({{ tab.count }})</span>
        </span>
        <span class="text-[10px] uppercase tracking-wide">
          {{ $t(tab.label) }}
        </span>
      </router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: "MobileTabBar",

  computed: {
    followingCount() {
      return Object.keys(this.$store.getters.seriesList).length;
    },
    tabs() {
      return [
        { to: "/dashboard", icon: "home", label: "home" },
        { to: "/explore", icon: "compass", label: "nav.explore" },
        { to: "/timeline", icon: "clock", label: "nav.timeline" },
        {
          to: "/following",
          icon: "heart",
          label: "nav.following",
          count: this.followingCount,
        },
      ];
    },
  },
};
</script>
